<div class="shop-container">
  <header class="shop-header">
    <h1 class="shop-title">COLECCIÓN 2026</h1>
    <p class="shop-subtitle">ESSENTIALS / STREETWEAR / LUXURY</p>
  </header>

  <div class="shop-toolbar">
    <button
      type="button"
      class="mobile-filter-btn"
      pButton
      icon="pi pi-filter"
      label="Filtros"
      (click)="openMobileFilters()">
    </button>

    <div class="results-meta" *ngIf="!isLoading">
      <span>{{ products.length }} producto{{ products.length === 1 ? '' : 's' }}</span>
    </div>

    <div class="sort-wrap">
      <label class="sort-label" for="shop-sort">Ordenar</label>
      <p-select
        inputId="shop-sort"
        [options]="sortOptions"
        [(ngModel)]="selectedSort"
        optionLabel="label"
        optionValue="value"
        (onChange)="onSortChange()"
        styleClass="shop-select"
        [fluid]="true">
      </p-select>
    </div>
  </div>

  <div class="shop-layout">
    <aside class="filters-sidebar">
      <div class="filters-panel">
        <div class="filters-panel-header">
          <h2>Filtros</h2>
          <button
            *ngIf="hasActiveFilters"
            type="button"
            class="clear-link"
            (click)="clearFilters()">
            Limpiar
          </button>
        </div>

        <div class="filter-group">
          <label class="filter-label" for="shop-search">Buscar</label>
          <input
            id="shop-search"
            pInputText
            type="text"
            class="w-full"
            placeholder="Nombre"
            [ngModel]="searchQuery"
            (ngModelChange)="onSearchInput($event)" />
        </div>

        <div class="filter-group">
          <label class="filter-label">Categoría</label>
          <p-select
            [options]="categories"
            [(ngModel)]="selectedCategoryId"
            optionLabel="name"
            optionValue="id"
            placeholder="Todas"
            [showClear]="true"
            (onChange)="onCategoryChange()"
            styleClass="shop-select"
            [fluid]="true">
          </p-select>
        </div>

        <div class="filter-group">
          <label class="filter-label">Marca</label>
          <p-select
            [options]="brands"
            [(ngModel)]="selectedBrandId"
            optionLabel="name"
            optionValue="id"
            placeholder="Todas"
            [showClear]="true"
            (onChange)="onBrandChange()"
            styleClass="shop-select"
            [fluid]="true">
          </p-select>
        </div>

        <div class="filter-group">
          <label class="filter-label">Modelo</label>
          <p-select
            [options]="modelos"
            [(ngModel)]="selectedModeloId"
            optionLabel="name"
            optionValue="id"
            placeholder="Todos"
            [showClear]="true"
            (onChange)="onModeloChange()"
            styleClass="shop-select"
            [fluid]="true">
          </p-select>
        </div>

        <div class="filter-group">
          <label class="filter-label">Talla</label>
          <p-select
            [options]="sizes"
            [(ngModel)]="selectedSizeId"
            optionLabel="name"
            optionValue="id"
            placeholder="Todas"
            [showClear]="true"
            (onChange)="onSizeChange()"
            styleClass="shop-select"
            [fluid]="true">
          </p-select>
        </div>

        <div class="filter-group" *ngIf="colors.length">
          <label class="filter-label">Color</label>
          <div class="color-swatches">
            <button
              type="button"
              class="color-swatch"
              *ngFor="let c of colors"
              [class.selected]="isColorSelected(c.hexCode)"
              [style.background-color]="c.hexCode"
              [title]="c.name"
              [attr.aria-label]="c.name"
              (click)="selectColor(c.hexCode)">
            </button>
          </div>
        </div>

        <div class="filter-group stock-row">
          <p-checkbox
            inputId="shop-stock"
            [(ngModel)]="inStockOnly"
            [binary]="true"
            (onChange)="onInStockChange()">
          </p-checkbox>
          <label for="shop-stock" class="stock-label">Solo con stock</label>
        </div>
      </div>
    </aside>

    <section class="shop-main">
      <div class="active-chips" *ngIf="hasActiveFilters">
        <p-chip
          *ngFor="let chip of activeChips"
          [label]="chip.label"
          [removable]="true"
          (onRemove)="removeChip(chip.key)">
        </p-chip>
        <button type="button" class="clear-link" (click)="clearFilters()">Limpiar todo</button>
      </div>

      <div *ngIf="isLoading" class="shop-loading">
        <p>Cargando catálogo...</p>
      </div>

      <div class="empty-state" *ngIf="!isLoading && loadError">
        <i class="pi pi-exclamation-triangle empty-icon"></i>
        <h3>No se pudo cargar el catálogo</h3>
        <p>Revisa tu conexión e intenta nuevamente.</p>
        <button type="button" pButton label="Reintentar" icon="pi pi-refresh" class="p-button-outlined" (click)="retryLoad()"></button>
      </div>

      <div class="empty-state" *ngIf="!isLoading && !loadError && filtersLoadError">
        <p>No se pudieron cargar los filtros del catálogo.</p>
        <button type="button" pButton label="Reintentar" icon="pi pi-refresh" class="p-button-outlined p-button-sm" (click)="retryLoad()"></button>
      </div>

      <div class="product-grid" *ngIf="!isLoading && !loadError && products.length > 0">
        <div
          *ngFor="let p of paginatedProducts; trackBy: trackByProductId"
          class="product-card"
          (click)="verProducto(p)">
          <div class="image-wrapper">
            <img [src]="p.image" [alt]="p.name">
            <span class="tag" [ngClass]="{'bg-red-500': hasOffer(p)}">
              {{ hasOffer(p) ? 'OFERTA' : 'Nueva Colección' }}
            </span>
          </div>

          <div class="product-info">
            <span class="category">{{ p.categoryName }}</span>
            <h3 class="name">{{ p.name }}</h3>
            <div class="price-row">
              <span *ngIf="hasOffer(p)" class="old-price">
                {{ p.price | currency:'PEN':'symbol':'1.2-2' }}
              </span>
              <span class="price">
                {{ (hasOffer(p) ? p.priceOffer : p.price) | currency:'PEN':'symbol':'1.2-2' }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="!isLoading && !loadError && products.length === 0">
        <i class="pi pi-search empty-icon"></i>
        <h3>No encontramos productos</h3>
        <p>Prueba ajustando o limpiando los filtros.</p>
        <button
          *ngIf="hasActiveFilters"
          type="button"
          pButton
          label="Limpiar filtros"
          icon="pi pi-filter-slash"
          class="p-button-outlined"
          (click)="clearFilters()">
        </button>
      </div>

      <div class="pagination-container" *ngIf="!isLoading && !loadError && products.length > 0 && totalPages > 1">
        <button class="pag-btn" [disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">
          <i class="pi pi-chevron-left"></i>
        </button>

        <div class="page-numbers">
          <button
            *ngFor="let page of pageNumbers"
            class="num-btn"
            [ngClass]="{'active': currentPage === page}"
            (click)="changePage(page)">
            {{ page }}
          </button>
        </div>

        <button class="pag-btn" [disabled]="currentPage === totalPages" (click)="changePage(currentPage + 1)">
          <i class="pi pi-chevron-right"></i>
        </button>
      </div>
    </section>
  </div>
</div>

<p-drawer
  [(visible)]="mobileFiltersVisible"
  position="left"
  [modal]="true"
  styleClass="shop-filters-drawer"
  header="Filtros">
  <div class="filters-panel drawer-panel">
    <div class="filter-group">
      <label class="filter-label" for="shop-search-m">Buscar</label>
      <input
        id="shop-search-m"
        pInputText
        type="text"
        class="w-full"
        placeholder="Nombre"
        [ngModel]="searchQuery"
        (ngModelChange)="onSearchInput($event)" />
    </div>

    <div class="filter-group">
      <label class="filter-label">Categoría</label>
      <p-select
        [options]="categories"
        [(ngModel)]="selectedCategoryId"
        optionLabel="name"
        optionValue="id"
        placeholder="Todas"
        [showClear]="true"
        (onChange)="onCategoryChange()"
        styleClass="shop-select"
        [fluid]="true">
      </p-select>
    </div>

    <div class="filter-group">
      <label class="filter-label">Marca</label>
      <p-select
        [options]="brands"
        [(ngModel)]="selectedBrandId"
        optionLabel="name"
        optionValue="id"
        placeholder="Todas"
        [showClear]="true"
        (onChange)="onBrandChange()"
        styleClass="shop-select"
        [fluid]="true">
      </p-select>
    </div>

    <div class="filter-group">
      <label class="filter-label">Modelo</label>
      <p-select
        [options]="modelos"
        [(ngModel)]="selectedModeloId"
        optionLabel="name"
        optionValue="id"
        placeholder="Todos"
        [showClear]="true"
        (onChange)="onModeloChange()"
        styleClass="shop-select"
        [fluid]="true">
      </p-select>
    </div>

    <div class="filter-group">
      <label class="filter-label">Talla</label>
      <p-select
        [options]="sizes"
        [(ngModel)]="selectedSizeId"
        optionLabel="name"
        optionValue="id"
        placeholder="Todas"
        [showClear]="true"
        (onChange)="onSizeChange()"
        styleClass="shop-select"
        [fluid]="true">
      </p-select>
    </div>

    <div class="filter-group" *ngIf="colors.length">
      <label class="filter-label">Color</label>
      <div class="color-swatches">
        <button
          type="button"
          class="color-swatch"
          *ngFor="let c of colors"
          [class.selected]="isColorSelected(c.hexCode)"
          [style.background-color]="c.hexCode"
          [title]="c.name"
          [attr.aria-label]="c.name"
          (click)="selectColor(c.hexCode)">
        </button>
      </div>
    </div>

    <div class="filter-group stock-row">
      <p-checkbox
        inputId="shop-stock-m"
        [(ngModel)]="inStockOnly"
        [binary]="true"
        (onChange)="onInStockChange()">
      </p-checkbox>
      <label for="shop-stock-m" class="stock-label">Solo con stock</label>
    </div>

    <div class="drawer-actions">
      <button
        type="button"
        pButton
        label="Limpiar"
        class="p-button-outlined p-button-secondary"
        (click)="clearFilters()">
      </button>
      <button
        type="button"
        pButton
        label="Ver resultados"
        (click)="applyMobileFilters()">
      </button>
    </div>
  </div>
</p-drawer>